import { IPresenceLocation } from './types'

const MAX_PATH_LENGTH = 512
const IDENTIFIER = /^[A-Za-z0-9_.:-]{1,128}$/

// /storage/:schemeName/:objectId[/details/...] — see src/router/index.tsx
const OBJECT_PAGE = /^\/storage\/([^/]+)\/([^/]+)(?:\/|$)/

/**
 * Location of the tab out of a router pathname. Only the pathname is ever reported:
 * query strings of the dashboard carry page state (modals, drafts), not a place.
 */
export const locationFromPathname = (
  pathname: string
): IPresenceLocation | null => {
  const path = pathname.split(/[?#]/)[0]

  if (
    !path.startsWith('/') ||
    path.startsWith('//') ||
    path.length > MAX_PATH_LENGTH
  ) {
    return null
  }

  const match = OBJECT_PAGE.exec(path)
  const scheme = match ? safeDecode(match[1]) : null
  const uniqId = match ? safeDecode(match[2]) : null

  return {
    path,
    screen: null,
    object:
      scheme && uniqId && IDENTIFIER.test(scheme) && IDENTIFIER.test(uniqId)
        ? { scheme, uniqId }
        : null,
  }
}

const safeDecode = (value: string) => {
  try {
    return decodeURIComponent(value)
  } catch (e) {
    return null
  }
}

export const isSameLocation = (
  a: IPresenceLocation | null,
  b: IPresenceLocation | null
) =>
  a?.path === b?.path &&
  a?.object?.scheme === b?.object?.scheme &&
  a?.object?.uniqId === b?.object?.uniqId
